export default "---\nname: Entangled Co-Consciousness Rig\n# owner: HORSE                 # optional: callsign of the pilot holding it\n---\n"